import axios from 'axios';
import { isStatic } from '../common/isStatic';
const API_URL = process.env.REACT_APP_API_LINK;


export const getAssignments = async () => {
    const lang = localStorage.getItem('lang')
    const language = lang === "ht" ? "haitian" : lang === "es" ? "spanish" : lang === "pt" ? "portuguese" : "english"
    try {
        const res = await axios.get(`assets/json/${language}.json`);
        if (!res.data) {
            const fallbackRes = await axios.get('assets/json/english.json');
            return fallbackRes.data?.skillAssignment?.filter(assignment => assignment.applicationName === "client-app") || [];
        }
        return res.data?.skillAssignment?.filter(assignment => assignment.applicationName === "client-app") || [];
    } catch {
        // If original request fails, try English as fallback
        const fallbackRes = await axios.get('assets/json/english.json');
        return fallbackRes.data?.skillAssignment?.filter(assignment => assignment.applicationName === "client-app") || [];
    }
}